import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['mm', 'm', 'km', 'ft', 'inch'] as const;
const unit = z.literal('m').default('m');

const validator = AbstractMeasurement.value.extend({
    unit: z.enum(units).default('m'),
});

export const Length = {
    validator,
    units,
    unit,
};
